import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Button from "../../components/Button/Button";
import FormActions from "../../components/FormActions/FormActions";
import TeamMemberInput from "../../components/TeamMemberInput/TeamMemberInput";
import { withFirebase } from "../../components/Firebase/Firebase";
import { withPrismic } from "../../components/Prismic/Prismic";
import RichText from "../../components/RichText/RichText";

// Scaffold object with fields for a new team member being added
const newTeamMember = {
	expanded: true,
	firstName: "",
	lastName: "",
	gender: "",
	schoolName: "",
	emailAddress: "",
	consentForm: "",
	mobileNumber: "",
	dateOfBirth: "",
	primaryContact: "",
	isValid: false
};

class Stage3 extends Component {
	state = {
		teamMembers: {}
	};
	
	componentDidMount() {
		// Look for any existing data
		if (
			this.props.entries[this.props.id] &&
			this.props.entries[this.props.id].members
		) {
			const entryData = this.props.entries[this.props.id];
			const teamMembers = {};
			// Transform the data slightly to add the expanded prop
			Object.keys(entryData.members).forEach((teamMemberId, ix) => {
				teamMembers[teamMemberId] = {
					...newTeamMember,
					...entryData.members[teamMemberId],
					expanded: ix === 0
				};
			});
			this.setState({
				teamMembers
			});
		}
	}
	
	continue = async () => {
		await this.props.methods.updateEntryStage(this.props.id, 4);
	};
	
	previous = async () => {
		await this.props.methods.updateEntryStage(this.props.id, 2);
	};
	
	addTeamMember = async () => {
		const newId = await this.props.methods.addTeamMemberToEntry(this.props.id);
		// Once we've got confirmation from firebase, update local state to match
		
		// Contract all other team members
		const teamMembers = {};
		
		// Transform the data slightly to add the expanded prop
		Object.keys(this.state.teamMembers).forEach((teamMemberId, ix) => {
			teamMembers[teamMemberId] = {
				...this.state.teamMembers[teamMemberId],
				expanded: false
			};
		});
		
		this.setState({
			teamMembers: {
				...teamMembers,
				[newId]: { ...newTeamMember }
			}
		});
	};
	
	removeTeamMember = async id => {
		await this.props.methods.removeTeamMemberFromEntry(this.props.id, id);
		const { teamMembers } = this.state;
		delete teamMembers[id];
		this.setState({
			teamMembers
		});
	};
	
	toggleTeamMember = id => {
		const { teamMembers } = this.state;
		Object.keys(teamMembers).forEach(teamMemberId => {
			teamMembers[teamMemberId].expanded = teamMemberId === id;
		});
		this.setState({
			teamMembers
		});
	};
	
	handleTeamMemberInputEvent = (e, key, id) => {
		const { teamMembers } = this.state;
		teamMembers[id][key] = e.target.value;
		this.setState({
			teamMembers
		});
	};
	
	// The date picker package doesn't send an event
	handleTeamMemberDateInputEvent = (data, key, id) => {
		const { teamMembers } = this.state;
		teamMembers[id][key] = data;
		this.setState({
			teamMembers
		});
	};
	
	// The primary contact checkbox behaves differently as it should unset all others
	handleTeamMemberPrimaryContactChange = (e, id) => {
		const { teamMembers } = this.state;
		if (teamMembers[id].primaryContact === "") {
			Object.keys(teamMembers).forEach(teamMemberId => {
				teamMembers[teamMemberId].primaryContact =
				teamMemberId === id ? "on" : "";
			});
		} else {
			teamMembers[id].primaryContact = "";
		}
		this.setState({
			teamMembers
		});
		// Upadte all team members
		this.props.methods.updateTeamMembers(this.props.id, this.state.teamMembers);
	};
	
	// This is a custom handler, it will update state with the new filename and pass the update back to firebase
	handleTeamMemberFileUpload = (filename, teamMemberId, key) => {
		const { teamMembers } = this.state;
		teamMembers[teamMemberId][key] = filename;
		this.setState(
			{
				teamMembers
			},
			() => {
				this.handleTeamMemberUpdate(null, teamMemberId);
			}
		);
	};
	
	handleTeamMemberUpdate = (e, id) => {
		this.props.methods.updateTeamMember(
			this.props.id,
			id,
			this.state.teamMembers[id]
		);
	};
	
	isValid = () => {
		let isValid = true;
		if (!Object.keys(this.state.teamMembers).length) {
			isValid = false;
		}
		Object.entries(this.state.teamMembers).forEach(([id, teamMember]) => {
			let isMemberValid = true;
			if (!teamMember.firstName) {
				isMemberValid = false;
			}
			if (!teamMember.lastName) {
				isMemberValid = false;
			}
			if (!teamMember.gender) {
				isMemberValid = false;
			}
			if (!teamMember.grade) {
				isMemberValid = false;
			}
			if (!teamMember.schoolName) {
				isMemberValid = false;
			}
			if (!teamMember.emailAddress) {
				isMemberValid = false;
			}
			if (!teamMember.consentForm) {
				isMemberValid = false;
			}
			if (!teamMember.mobileNumber) {
				isMemberValid = false;
			}
			if (!teamMember.dateOfBirth) {
				isMemberValid = false;
			}
			// If validation has changed, update the member
			if(teamMember.isValid !== isMemberValid) {
				teamMember.isValid = isMemberValid;
				this.setState({teamMembers : {
					...this.state.teamMembers,
					[id]: teamMember
				}})
			}
			if(!isMemberValid) isValid = false;
			
			
		});
		
		return isValid;
	};
	
	render() {

		if(!this.props.terms) return null;

		return (
			<div>


			<div className="step-header">
				Step 2 of 5
			</div>
			
			<RichText content={this.props.terms.stage_3} />
			{Object.keys(this.state.teamMembers).map(teamMemberId => {
				const teamMember = this.state.teamMembers[teamMemberId];
				return (
					<TeamMemberInput
					{...teamMember}
					key={teamMemberId}
					entryId={this.props.id}
					teamMemberId={teamMemberId}
					removeSelf={() => this.removeTeamMember(teamMemberId)}
					toggleSelf={() => {
						this.toggleTeamMember(teamMemberId)
					}}
					handleUpdate={e => {
						this.handleTeamMemberUpdate(e, teamMemberId);
					}}
					handleInputEvent={(e, key) =>
						this.handleTeamMemberInputEvent(e, key, teamMemberId)
					}
					handleDateInputEvent={(data, key) =>
						this.handleTeamMemberDateInputEvent(data, key, teamMemberId)
					}
					handlePrimaryContactEvent={e =>
						this.handleTeamMemberPrimaryContactChange(e, teamMemberId)
					}
					handleFileUpload={(filename, key) =>
						this.handleTeamMemberFileUpload(filename, teamMemberId, key)
					}
					/>
				);
			})}
			<FormActions
			left={
				<div>
				<Button onClick={this.previous} type="">
				Back
				</Button>
				</div>
			}
			right={
				<div>
				<Button onClick={this.addTeamMember} type="">
				Add Person
				</Button>
				<Button
				onClick={this.continue}
				type={["primary","emphasis"]}
				disabled={!this.isValid()}
				>
				Finished
				</Button>
				</div>
			}
			/>
			</div>
		);
	}
}

export default withRouter(withPrismic(withFirebase(Stage3)));



// WEBPACK FOOTER //
// ./src/pages/CompetitionEnter/Stage3.js